import axios from "axios";
import React, { Component,useEffect,createRef } from "react";
import { connect } from "react-redux";
import { Chart } from "react-google-charts";
import {set_datapage} from '../../redux/actions/DataPageAction'
import { baseUrl,localUrl } from "@ora/recursos/src/helpers/Url";
import qs from 'query-string'
import "css/reportes/scrollbar.css";
import Swal from 'sweetalert2'
import { Button, 
    Card, 
  
    Section, 
    Form,
     } from 'react-bulma-components';


const Modal = ({ children, closeModal, modalState, title, onClickSave }) => {
  if(!modalState) {
    return null;
  }
  return(
    <div className="modal is-active">
      <div className="modal-background" onClick={closeModal} />
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">{title}</p>
          <button className="delete" onClick={closeModal} />
        </header>
        <section className="modal-card-body">
          <div className="content">
            {children}
          </div>
        </section>
        <footer className="modal-card-foot">
          <a className="button" onClick={closeModal}>Cancel</a>
          <a className="button is-primary" onClick={onClickSave}>Guardar</a>
        </footer>
      </div>
    </div>
  );
}


class GanttChart extends Component{
  constructor(props){
    super(props)
    
  }

  datediff(d1,d2){
      let t2 = d2.getTime();
      let t1 = d1.getTime();

      return parseInt((t2-t1)/(24*3600*1000));
  }

  construirData(planes){
    
    let data=[
      [
        { type: 'string', label: 'Task ID' },
          { type: 'string', label: 'Task Name' },
          { type: 'date', label: 'Start Date' },
          { type: 'date', label: 'End Date' },
          { type: 'number', label: 'Duration' },
          { type: 'number', label: 'Percent Complete' },
          { type: 'string', label: 'Dependencies' }
      ]
    ]

    planes.forEach(element => {
      console.log(element)
      let plan =  [
        element[0],
        element[1],
        element[2],
        element[3],
        this.datediff(element[2],element[3]),
        100,
        null,
      ]

      data.push(plan)


    });


    return data
      
    
  }

 



  render(){
        
    return (
    
      <Chart
      width={'100%'}
      height={'400px'}
      chartType="Gantt"
      loader={<div>Loading Chart</div>}
      data={this.construirData(this.props.data)}
      rootProps={{ 'data-testid': '1' }}
    />);

}
}


class Actividades extends Component {
    
    state = {
        tipos: [],
        pais: [],
        idioma: [],
        planes: {},
        isgantt : false
      }
    constructor (props) {
        super(props)
        this.props.set_datapage('Formulario de Actividades')
        
        this.search={txt_ncc:"",sel_cites: "", sel_iucn: "",sel_recurso: "",sel_pais: ""}     
        this.handleBusqueda=this.handleBusqueda.bind(this)
        this.frmGuardar = createRef()
        this.toggleModal = this.toggleModal.bind(this);
        
      axios.get(baseUrl('aro/variable/resource')).then(res => {
        if (res.data.success) {
            this.setState({
                tipos: res.data.data
            })
            
        }
      })

      this.cargarTablaAxios()

      axios.get(baseUrl('cites/pais/actives')).then(res => {
        if (res.data.success) {
            this.setState({
                pais: res.data.data
            })
            
        }
      })
      axios.get(baseUrl('cites/config/gpais')).then(res => {
        //console.log(res.data.lenguaje)
        
            this.setState({
                idioma: res.data.lenguaje
            })
            
        
      })

      
    }

    cargarTablaAxios(){
      var idplan=this.props.match.params.idplan
      axios.get(baseUrl('cites/planificacion/getactividades/'+idplan)).then(res => {
        if (res.data.success) {
          this.setState({
              planes: res.data.data
          })
          
        }
        this.creartabla(res.data.data)

      })
    }

    creartabla(rows){

      let planes = []

      const tabla = rows.map((item,index)=>{

        planes.push([item.psa_int_id,item.psa_txt_name,new Date(item.psa_txt_startdate),new Date(item.psa_txt_enddate)])
        //console.log(Date.parse(item.pls_txt_startdate))

          
          return (<tr>
              <th>{index+1}</th>
              <th>{item.psa_txt_name}</th>
              <th>{item.psa_txt_description}</th>
              <th>{item.psa_txt_startdate}</th>
              <th>{item.psa_txt_enddate}</th>
              <th>
              <button type="button" data-id="${d}" onClick={()=>{this.toggleModal(index)}}  data-accion="editar" className="button is-small is-info btn-acciones" title="Editar">
                  <span className="icon is-small"><i className="fas fa-pen"></i></span>
              </button>
              <button type="button" data-id="${d}" data-accion="estado" className="button is-small is-info btn-acciones" title="Estado">
                  <span className="icon is-small"><i className="fas fa-sync"></i></span>
              </button>
              <button type="button" data-id="${d}" data-accion="eliminar" className="button is-small is-info btn-acciones" title="Eliminar">
                  <span className="icon is-small"><i className="fas fa-trash"></i></span>
              </button>
              </th>
          </tr>)
      });

      let chart=<GanttChart data={planes}></GanttChart>


      this.setState({
          rows : rows,
          tabla : tabla,
          chart : chart
      })
    }



    COptionTipo = (idtipo=-1) => {
        return this.state.tipos.map((item, index) => {
          if(item.id==idtipo){
            return  <option selected={true} key={ index } value={ item.id }>{ item.name }</option>
          }
          else{
            return <option key={ index } value={ item.id }>{ item.name }</option>
          }
          
        })
    
      }
    
    COptionIdioma = () => {
    return this.state.idioma.map((item, index) => {
        return <option key={ index } value={ item.id }>{ item.name }</option>
    })

    }



    componentDidMount() {
        var params=qs.parse(this.props.location.search)
        var idplan=this.props.match.params.idplan
        var url=baseUrl(`aro/documentos/getdocumento?l=25&o=0`)
        
        //alert(res.data.length);
        axios.get(url).then(res => {
            
            this.initpage(res.data,idplan);
           
        })
        //alert(res.data.length);
    }
    initpage(result,idplan){
        var resultados = result;
        var idplan = idplan;
        this.setState({
            totaldoc: resultados.totaldoc,
            idplan:idplan
        })
        
    }


    buscar_simple = () => {
        //this.getSearch();
        var url=localUrl("/reportes/listadoc?t="+this.state.valorBusqueda)
        this.props.history.push(localUrl(url))      
    }


    handleBusqueda(e){
        const value=e.target.value.replace(/ /g, "-");
        this.setState({
          valorBusqueda: value
      })
    }

    guardarPlan = (e) => {
      e.preventDefault()
      
      axios.post(baseUrl('cites/actividad'), new FormData(this.frmGuardar.current)).then(res => {
        if (res.data.success) {
          this.frmGuardar.current.reset()

          this.cargarTablaAxios()
          Swal.fire(
            'Actividad',
            res.data.message,
            'success'
          )
        }
      })
          
   }
   
   toggleModal(index) {    
    this.setState((prev, props) => {

      
      const newState = !prev.modalState;
      //console.log(prev.rows[index].pls_txt_startdate)
      //const fecha = '2021-05-01 '
      if(newState){
          this.setState({
            editNombre:prev.rows[index].psa_txt_name.trim(),
            editDescripcion:prev.rows[index].psa_txt_description,
            editFechaini:prev.rows[index].psa_txt_startdate.trim(),
            editFechafin:prev.rows[index].psa_txt_enddate.trim(),
            editDesembolso:prev.rows[index].psa_txt_actualdisbursment,
            editPresupuesto:prev.rows[index].psa_int_budget,
            editTipo:prev.rows[index].var_int_id 
          })
      }


      
      return { modalState: newState
       };
    });
  }

    render() {
      let renderplanes, textbutton
      if(!this.state.isgantt){
        textbutton='Ver en Diagrama de Gantt'
        renderplanes=<div className="card">
        <div className="column">
            <div className="columns is-desktop has-text-centered">
            <table className="table is-fullwidth is-striped is-hoverable is-fullwidth">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Nombre del Plan</th>
                                    <th>Descripcion</th>
                                    <th>Fecha Inicio</th>
                                    <th>Fecha Final</th>
                                    <th>Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                            {this.state.tabla}
                            </tbody>
                        </table>
            </div>  
        </div>
    </div>
      }
      else{
        textbutton='Ver en Lista'
        renderplanes=<div>{this.state.chart}</div>
        
      }

        return (
        <div className="is-main-section">
            <Card>
              <Card.Header>
                 <Card.Header.Title>
                     <span className="icon"><i className="fas fa-file-invoice"></i></span>Nueva Actividad
                     
                 </Card.Header.Title>
                
              </Card.Header>
              <Card.Content>
                <form ref={ this.frmGuardar } onSubmit={this.guardarPlan} method = "POST">
                  <input type="hidden" name="idplan" value={this.state.idplan}/>
                  <div className="field is-horizontal">
                    <div className="field-label is-normal"><label className="label">Nombre de la Actividad</label></div>
                    <div className="field-body">
                      <div className="field columns">
                        <div className="field column is-8">
                          <div className="control is-clearfix"><input type="text"
                              placeholder="Nombre de la Actividad" name="name" required="required" className="input form-control" maxLength="100" />
                                </div>
                          <p className="help">0 / 100  </p>
    
                        </div>
                      </div>
                    
                    </div>
                  </div>
                   <div className="field is-horizontal">
                    <div className="field-label is-normal"><label className="label">Descripción</label></div>
                    <div className="field-body">
                      <div className="field columns">
                        <div className="control column is-8">
                          <textarea maxLength="400" name="descripcion" placeholder="Descripcion de la Actividad"
                            required="required" className="textarea"></textarea>
                            <small className="help counter"> 0 /
                            400 </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="field is-horizontal">
                    <div className="field-label is-normal"><label className="label">Fecha Inicial</label></div>
                    <div className="field-body">
                      <div className="field columns is-vcentered ">
                        <div className="control column is-3">
                        <input className="input is-normal" name="fechainicial" type="date" ></input>
                        </div>
                        <div className="control">
                        <label className="label">Fecha Final</label>
                        </div>
                        <div className="control column is-3">
                        <input className="input is-normal" name="fechafinal" type="date" ></input>
                        </div>
                      </div>
                    </div>
                  </div>
               
                  <div className="field is-horizontal">
                    <div className="field-label is-normal"><label className="label">Tipo</label></div>
                     <div className="field-body">
                      <div className="field columns is-vcentered ">
                        <div className="control column is-3">
                            <div className="control"><span className="select is-empty">
                            <select required="required" name="selectipo" min="1">
                                <option value="-1">- Seleccionar -</option>
                                { this.COptionTipo() }
                                </select></span></div>
                        </div>
                        <div className="control">
                            <label className="label">Presupuesto ($)</label>
                        </div>
                        <div className="control column is-2">
                            <input className="input is-normal" name="presupuesto" type="number" ></input>
                        </div>
                        <div className="control">
                            <label className="label">Desembolso</label>
                        </div>
                        <div className="control column is-3">
                            <input className="input is-normal" name="deseembolso" type="text" ></input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="field is-horizontal">
                    <div className="field-label is-normal"><label className="label">Idioma</label></div>
                        <div className="field-body">
                            <div className="field columns is-vcentered ">
                                <div className="control column is-3">
                                    <div className="control"><span className="select is-empty">
                                    <select required="required" name="selectidioma" min="1">
                                        <option value="-1">- Seleccionar -</option>
                                        { this.COptionIdioma() }
                                        </select></span></div>
                                </div>
                            </div>
                        </div>
                  </div>
                
                  <hr/>
                 <div className="field is-horizontal">
                   <div className="field-label is-normal" />
                   <div className="field-body">
                     <div className="field">
                       <div className="field">
                         <div className="field-body">
                           <div className="field is-grouped">
                             <div className="control"><button type="submit"
                                 className="button is-primary"><span>Guardar</span></button></div>
                             
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
                </form>
              </Card.Content>
            </Card>
            <div className="columns">
              <div className="column">
              <font size="3"><h1 className="tamano">Lista de Actividades</h1></font>
              </div>
              <div className="column is-offset-7">
              <button onClick={()=>{this.setState((state)=>({isgantt: !state.isgantt}))}} className="button is-primary"><span>{textbutton}</span></button>
              </div>
                    
            </div>
            {renderplanes}
        
            <Modal closeModal={this.toggleModal} modalState={this.state.modalState}  title="Editar Plan">
            <form ref={ this.frmGuardar } onSubmit={this.guardarPlan} method = "POST">
                  <div className="field is-horizontal">
                    <div className="field-label is-normal"><label className="label">Nombre del Plan</label></div>
                    <div className="field-body">
                      <div className="field columns">
                        <div className="field column is-8">
                          <div className="control   is-clearfix"><input type="text"
                              placeholder="Nombre del Plan" name="name" required="required" className="input form-control" maxLength="100" value={this.state.editNombre}/>
                                </div>
                          <p className="help">0 / 100  </p>
    
                        </div>
                      </div>
                    
                    </div>
                  </div>
                   <div className="field is-horizontal">
                    <div className="field-label is-normal"><label className="label">Descripción</label></div>
                    <div className="field-body">
                      <div className="field columns">
                        <div className="control column is-8">
                          <textarea maxLength="400" name="descripcion" placeholder="Descripcion del Plan"
                            required="required" className="textarea">{this.state.editDescripcion}</textarea>
                            <small className="help counter"> 0 /
                            400 </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="field is-horizontal">
                    <div className="field-label is-normal"><label className="label">Fecha Inicial</label></div>
                    <div className="field-body">
                      <div className="field columns is-vcentered ">
                        <div className="control column is-5">
                        <input className="input is-normal" name="fechainicial" type="date" value={this.state.editFechaini}></input>
                        </div>
                        <div className="control">
                        <label className="label">Fecha Final</label>
                        </div>
                        <div className="control column is-5">
                        <input className="input is-normal" name="fechafinal" type="date" value={this.state.editFechafin}></input>
                        </div>
                      </div>
                    </div>
                  </div>
               
                  <div className="field is-horizontal">
                    <div className="field-label is-normal"><label className="label">Tipo</label></div>
                     <div className="field-body">
                      <div className="field columns is-vcentered ">
                        <div className="control column is-4">
                            <div className="control"><span className="select is-empty">
                            <select required="required" name="selectipo" min="1">
                                <option value="-1">{this.state.editTipo}</option>
                                { this.COptionTipo(this.state.tipoId) }
                                </select></span></div>
                        </div>
                        <div className="control">
                            <label className="label">Presupuesto ($)</label>
                        </div>
                        <div className="control column is-4">
                            <input className="input is-normal" name="presupuesto" type="number" value={this.state.editPresupuesto}></input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="field is-horizontal">
                    <div className="field-label is-normal"><label className="label">Desembolso</label></div>
                     <div className="field-body">
                      <div className="field columns is-vcentered ">
                      <div className="control column is-4">
                                    <input className="input is-normal" name="deseembolso" type="text" value={this.state.editDesembolso} ></input>
                                </div>
                      </div>
                    </div>
                  </div>
              {/* ``    <div className="field is-horizontal">
                    <div className="field-label is-normal"><label className="label">Pais</label></div>
                        <div className="field-body">
                            <div className="field columns is-vcentered ">
                                <div className="control column is-4">
                                    <div className="control"><span className="select is-empty">
                                    <select required="required" name="selecpais" min="1">
                                        <option value={this.state.editPais}>{this.state.editPais}</option>
                                        { this.COptionPais() }
                                        </select></span></div>
                                </div>
                                <div className="control">
                                    <label className="label">Idioma</label>
                                </div>
                                <div className="control column">
                                    <span className="select is-empty">
                                        <select required="required" name="selectidioma">
                                            <option disabled="disabled" hidden="hidden" value=""></option>
                                            <option value={this.state.editIdioma}>{this.state.editIdioma}</option>
                                            { this.COptionIdioma() }
                                        </select>
                                    </span>
                                </div>
                            </div>
                        </div>
                  </div>`` */}
                
                  <hr/>
               
                </form>
                   
            </Modal>
                
          </div>
          
        )
    }
}


export default connect(null, {set_datapage})(Actividades)